var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDefaultPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 62,
    viewBox: "0 0 72 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5799 61H11.6509C5.7929 61 1 56.0909 1 50.0909V11.9091C1 5.90909 5.7929 1 11.6509 1H59.5799C65.4379 1 70.2308 5.90909 70.2308 11.9091V50.0909C70.2308 56.0909 65.4379 61 59.5799 61Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6509 61H59.5799C65.4379 61 70.2308 56.1262 70.2308 50.1693V31.2154L59.5799 20.3846L31.8876 46.3785L19.6391 33.9231L1 51.2523C1.79882 56.6677 6.05917 61 11.6509 61Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1076 21.0765C16.6566 21.0765 18.723 19.0101 18.723 16.4611C18.723 13.9121 16.6566 11.8457 14.1076 11.8457C11.5586 11.8457 9.49219 13.9121 9.49219 16.4611C9.49219 19.0101 11.5586 21.0765 14.1076 21.0765Z",
    fill: "#F6F8F9",
    stroke: "#F6F8F9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultPic);
export default __webpack_public_path__ + "static/media/user-default-pic.11f8eae3095363f563b0082031b32d3c.svg";
export { ForwardRef as ReactComponent };